import styled from 'styled-components';

export const StyledHealthcarePracticeDataPanelPracticeDetails = styled.div`
   display: grid;
   grid-template-columns: 1fr 431px;
   grid-template-rows: auto 1fr;
   grid-row-gap: 24px;
`;
StyledHealthcarePracticeDataPanelPracticeDetails.displayName = 'StyledHealthcarePracticeDataPanelPracticeDetails';
